import { render } from "./AxcessCardFlow.vue?vue&type=template&id=971f451a&scoped=true"
import script from "./AxcessCardFlow.vue?vue&type=script&lang=js"
export * from "./AxcessCardFlow.vue?vue&type=script&lang=js"

import "./AxcessCardFlow.vue?vue&type=style&index=0&id=971f451a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971f451a"]])

export default __exports__